module.exports = __webpack_public_path__ + "resources/img/img_maxgauge3_m.244d9b14c7a75e6bc0c7849320caedd5.png";